import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash-es/isEmpty";
import every from "lodash-es/every";

import { FormTextField, FormGroupTitle } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import useOtaHmacData from "hooks/packages/useOtaHmacData";

import { UPDATE_OTA_HMAC, READ_OTA_HMAC_NAME } from "graphqlQueries/packages";
import { hmacInfoMapper } from "graphqlQueries/packages.map";
import { createEditOtaHmacValidator } from "validators/packagesValidators";

const fieldsWithPlaceForError = ["aota_pkg_version", "hmac_secret_b64url"];

const UpdateOtaHmacDialog = (props) => {
  const {
    id,
    initialValues = {
      aota_pkg_version: "",
      hmac_secret_b64url: "",
    },
    onClose,
  } = props;
  const getHmacData = useOtaHmacData();
  const data = useMemo(() => getHmacData(), []);

  const dataMapper = useCallback(
    (value) => {
      let secrets;
      if (id !== undefined) {
        secrets = data.map((hmacInfo) =>
          hmacInfo.id === id ? value : hmacInfoMapper(hmacInfo),
        );
      } else {
        secrets = data.map(hmacInfoMapper);
        secrets.push(value);
      }
      return { secrets };
    },
    [id, data],
  );

  const titlePrefix = every(
    [
      isEmpty(initialValues.aota_pkg_version),
      isEmpty(initialValues.hmac_secret_b64url),
    ],
    Boolean,
  )
    ? "Add"
    : "Edit";

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_OTA_HMAC}
      refetchQueries={[READ_OTA_HMAC_NAME]}
      dataMapper={dataMapper}
      initialValues={initialValues}
      validationSchema={createEditOtaHmacValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`${titlePrefix} HMAC`}
      submitButtonName="Save"
      className="dialog-default-width"
      onClose={onClose}
    >
      <FormGroupTitle title="HMAC Info" />
      <FormTextField name="aota_pkg_version" label="Version" />
      <FormTextField name="hmac_secret_b64url" label="HMAC" />
    </DialogFormWithMutation>
  );
};

UpdateOtaHmacDialog.propTypes = {
  id: PropTypes.number,
  initialValues: PropTypes.shape({
    aota_pkg_version: PropTypes.string.isRequired,
    hmac_secret_b64url: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};

export default UpdateOtaHmacDialog;
